module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt":{"notifications":{"notification_list":"Lista de notificações"}},"en":{"notifications":{"notification_list":"Notifications list"}}}')
  delete Component.options._Ctor
}
